import { render, staticRenderFns } from "./ProductsQuantityNumberField.vue?vue&type=template&id=dfd84c74"
import script from "./ProductsQuantityNumberField.vue?vue&type=script&lang=ts"
export * from "./ProductsQuantityNumberField.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports